import { AxiosResponse } from "axios";
import { getFilenameFromContentDisposition } from "./file";

// 下载文件
export function downloadByUrl(url: string, filename?: string) {
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

// 下载二进制文件
export function downloadBinaryFile(data: AxiosResponse) {
  // 创建 Blob URL
  const blob = new Blob([data.data], { type: "application/xlsx" });
  const url = window.URL.createObjectURL(blob);

  // 从响应头获取文件名
  const contentDisposition = data.headers["content-disposition"];

  const filename = getFilenameFromContentDisposition(contentDisposition);
  // 创建临时链接并触发下载
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();

  // 清理
  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
}
